<template>
   <v-row class="fill-height align-center no-gutters">
        <v-col class="d-flex flex-column justify-center col-6 fill-height">
            <image-mobile-app></image-mobile-app>
        </v-col>
        <v-col class="d-flex flex-column align-center">
            <span v-if="status!='done'">
                <h4 class="mb-5 ">Mot de passe oublié ?</h4>
            </span>
            <span class="wi-70 d-flex flex-column" v-if="status !== 'done'">
                <v-text-field label="Votre adresse email"  v-model="email"></v-text-field>
                <v-btn  @click="resetPassword()" class="primary-button mx-auto ">Envoyer</v-btn>
                <router-link to="/login" class="cursor-pointer caption text-decoration-none mt-5 d-block secondary-hover">Vous vous rappelez de votre mot de passe ? Connectez-vous !</router-link>
            </span>
            <span v-if="status === 'done'">
                <p class="mb-5 mt-5">
                    Merci de vérifier dans vos emails. Un lien vous a été envoyé afin de mettre à jour votre mot de passe.
                </p>
            </span>
        </v-col>
    </v-row>
</template>

<style lang="scss">
</style>

<script>
import imageMobileApp from '@/components/ImageMobileApp.vue'
import Vue from 'vue'
import axios from 'axios'
import { apiURL, recaptchaKey } from '@/../config'
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: recaptchaKey })


export default {
    name: 'login',
    components: { imageMobileApp },
    data () {
        return {
            email: undefined,
            status: ''
        }
    },
    created () {
    },
    methods: {
        async resetPassword () {
            try {
                this.$store.dispatch('loading')
                const recaptcha = await this.$recaptcha('register')
                await axios.post(apiURL + 'public/forgot-password/', { email: this.email, recaptcha })
            } catch (e) {
                console.log(e)
                this.$store.dispatch('open_dialog', { message: 'Wrong account or password. Authentification failed please retry.' })
            } finally {
                this.$store.dispatch('stop_loading')
            }
        }
    }
}
</script>

<style>

</style>